import { render, staticRenderFns } from "./SearchListCard.vue?vue&type=template&id=5bd4c040&scoped=true"
import script from "./SearchListCard.vue?vue&type=script&lang=js"
export * from "./SearchListCard.vue?vue&type=script&lang=js"
import style0 from "./SearchListCard.vue?vue&type=style&index=0&id=5bd4c040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd4c040",
  null
  
)

export default component.exports